export const data = {
      personal_info: {
        profileImg: "",
        firstName: "Indira",
        lastName: "M",
        email: "indira@gmail.com",
        mobile: "+917895632548",
        address: "623, Surya Colony, Sehatpur",
        city: "Faridabad",
        state: "Haryana",
        postal_code: "121003",
        objective:
          "Secure a responsible career opportunity to fully utilize my training and skills, while making a significant contribution to the success of the company."
      },
    
      work_experience: [
        {
          id: 1,
          jobTitle: "Life insurance Advisor",
          organization_name: "Lic Of India",
          startYear: "2020",
          endYear: "2022",
        },
        {
          id: 2,
          jobTitle: "Algo Trader",
          organization_name: "Enable Investor",
          startYear: "2022",
          endYear: "2022",
        },
      ],
      education_details: {
        type: "Graduation",
        university: "Delhi University",
        degree: "B.Com",
        startYear: "2020",
        endYear: "2023",
      },
      key_skills: ["React JS", "MERN Stack", "UI/UX"],
    };
    